import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import HostsList from './HostsList/HostsList';
import HostManagement from './HostManagement/HostManagement';

const Hosts = () => {
    const { path } = useRouteMatch();
    return (
        <div className="Hosts">
            <Switch>
                <Route exact path={path}><HostsList /></Route>
                <Route exact path={`${path}/manage/:hostId`}><HostManagement /></Route>
            </Switch>
        </div>
    );
}

export default Hosts;
